import styled from 'styled-components';

export const ModalCloseButton = styled.div`
  .dialog-close {
    position: static;
  }
`;
